import { render, staticRenderFns } from "./ResourceItem.vue?vue&type=template&id=2e3b66e4&scoped=true&"
import script from "./ResourceItem.vue?vue&type=script&lang=js&"
export * from "./ResourceItem.vue?vue&type=script&lang=js&"
import style0 from "./ResourceItem.vue?vue&type=style&index=0&id=2e3b66e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b66e4",
  null
  
)

export default component.exports